// extracted by mini-css-extract-plugin
export default {"container":"TCPFooter_container__v9ViJ","logo":"TCPFooter_logo__3eNxi","text":"TCPFooter_text__u6iS1"};